
define('text!presentation/account/views/account.html',[],function () { return '<nav class="main-navigation">\n    Hello\n</nav>\n\n';});

